import type {
  DateFilterKey,
  FilterCondition,
  FilterField,
  MultiSelectFilterKey,
} from "./documentFilters";
import {
  buildFilterParamKeysForField,
  buildSearchParamsFromFilters,
  dateFilterKeys,
  filterFields,
  multiSelectFilterKeys,
} from "./documentFilters";

interface CreateDocumentFilterUrlStateOptions {
  multiSelectFields?: readonly MultiSelectFilterKey[];
  dateFields?: readonly DateFilterKey[];
}

interface DocumentFilterUrlState {
  viewFilterParamKeys: readonly string[];
  hasViewFilterParams: boolean;
  replaceDocumentFilterParams: (filters: FilterCondition[]) => URLSearchParams;
}

const globalFilterParamKeys = [
  ...new Set(
    filterFields.flatMap((field) => buildFilterParamKeysForField(field)),
  ),
];

export const createDocumentFilterUrlState = (
  searchParams: URLSearchParams,
  options: CreateDocumentFilterUrlStateOptions = {},
): DocumentFilterUrlState => {
  const {
    multiSelectFields = multiSelectFilterKeys,
    dateFields = dateFilterKeys,
  } = options;
  const viewFilterFields = new Set<FilterField>([
    ...multiSelectFields,
    ...dateFields,
  ]);
  const viewFilterParamKeys = [
    ...new Set(
      [...viewFilterFields].flatMap((field) =>
        buildFilterParamKeysForField(field),
      ),
    ),
  ];

  const replaceDocumentFilterParams = (filters: FilterCondition[]) => {
    const next = new URLSearchParams(searchParams);
    globalFilterParamKeys.forEach((key) => next.delete(key));
    buildSearchParamsFromFilters(
      filters.filter((filter) => viewFilterFields.has(filter.field)),
    ).forEach((value, key) => next.append(key, value));
    return next;
  };

  return {
    viewFilterParamKeys,
    hasViewFilterParams: viewFilterParamKeys.some((key) =>
      searchParams.has(key),
    ),
    replaceDocumentFilterParams,
  };
};
